import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Box = styled.div`
padding-top: 16px;
`;

const Title = styled.div`
padding: 4px 12px;
	margin-bottom: 16px;
	border-radius: 8px;
	background-color: #F8EEFF;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	color: #49028E;
	text-align: start;
`;

const Text = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #9B92BB;
	text-align: left;
`;

const TermsConditions = ({ title, rule }) => {
	const { t } = useTranslation();

	return (
		<Box>
			<Title>{`${title} ${t("common.termsAndConditions")}`}</Title>
			<Text dangerouslySetInnerHTML={{ __html: rule }} />
		</Box>
	);
};

export default TermsConditions;
